import React from "react";
import Chart from "react-apexcharts";

const PieChart = ({ data }) => {
    if (!data) {
        return <div>Loading...</div>;
    }

    const chartData = {
        series: data.series[0].data,
        options: {
            chart: {
                type: "pie",
                toolbar: {
                    show: true,
                    tools: {
                        download: false, // ❌ removes download option
                    },
                },
                animations: {
                    enabled: true,
                    easing: "easeinout",
                    speed: 800,
                    animateGradually: {
                        enabled: true,
                        delay: 150,
                    },
                    dynamicAnimation: {
                        enabled: true,
                        speed: 550,
                    },
                },
            },
            tooltip: {
                enabled: true,
                style: {
                    fontSize: "12px"
                },
                theme: "dark", // base theme
            },
            title: {
                text: data.options.title.text,
                align: "center",
                style: {
                    fontSize: "12px",
                    fontWeight: "600",
                    color: "white", // Title text color
                },
            },
            labels: data.options.xaxis.categories,
            yaxis: {
                labels: {
                    style: {
                        colors: "white",   // Y-axis text color
                        fontSize: "12px",
                    },
                },
            },
            dataLabels: {
                enabled: false,
            },
            legend: {
                labels: {
                    colors: "#aaa", // default legend text color
                    useSeriesColors: false
                },
                onItemClick: {
                    toggleDataSeries: true
                },
                formatter: function (seriesName, opts) {
                    const isActive = opts.w.globals.series[opts.seriesIndex] !== 0;
                    return `<span style="color:${isActive ? '#ffffff' : '#666'}">${seriesName}</span>`;
                }
            }

        },
    };

    return (
        <Chart
            options={chartData.options}
            series={chartData.series}
            type="pie"
            height={350}
        />
    );
};

export default PieChart;
